import Country from "../../../../enums/Country";

const countryIDMap = {
  1: Country.ENGLAND,
  2: Country.FRANCE,
  3: Country.ITALY,
  4: Country.GERMANY,
  5: Country.AUSTRIA,
  6: Country.TURKEY,
  7: Country.RUSSIA,
};

export default countryIDMap;
